// extracted by mini-css-extract-plugin
module.exports = {"modal-body":"modal-body-2wmxNim"};